import { AdminBlockAttributeInputType, AdminBlockTypeAttribute } from '@headlines/types/block/adminBlockType';

const backgroundColor: AdminBlockTypeAttribute = {
  label: 'Show background color',
  key: 'backgroundColor',
  inputType: AdminBlockAttributeInputType.COLOR_PICKER,
};

export default backgroundColor;
